import Joi from "joi";

export const statusSchema = Joi.object({
  title: Joi.string().min(2).label("Title"),
  badgeColor: Joi.string().min(2).label("Color"),
  order: Joi.number().min(1).label("Order"),
  isDefault: Joi.boolean().label("Is Default"),
  isCompleted: Joi.boolean().label("Is Completed"),
  isReadOnly: Joi.boolean().label("Is Read Only"),
  isReadyForReview: Joi.boolean().label("is Ready For Review"),
});
